module.exports = __webpack_public_path__ + "img/angle-up.b956ee23.svg";